import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import * as XLSX from "xlsx";
import { productsApi } from "../api/productsApi";
import { db } from "../firebase";
import {
  doc,
  getDoc,
  updateDoc,
  collection,
  getDocs,
  setDoc,
  writeBatch,
  addDoc,
  query,
  where,
  orderBy,
  limit,
  QueryDocumentSnapshot,
  DocumentData,
  startAfter,
  deleteDoc,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faTrash,
  faSearch,
  faPlus,
  faFolderOpen,
} from "@fortawesome/free-solid-svg-icons";

import "../screenstyles/EditProduct.css"
interface Tag {
  id: string;
  name: string;
  imageUrl: string;
}

interface ProductImage {
  id: string;
  imageUrl: string;
}
// ✅ تعريف نوع المودال Props
interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
interface Brand {
  id: string;
  name: string;
  nameAr: string;
  logoUrl?: string;
  isActive: boolean;
  sortOrder: number;
}

type CategoryType = "main" | "sub" | "leaf";

interface Category {
  id: string;
  name: string;
  nameAr: string;
  type: CategoryType;
  parentId: string | null;
  level: number;
  isActive: boolean;
  sortOrder: number;
}

interface FilterOption {
  id: string;
  name: string;
  nameAr: string;
  isActive: boolean;
  sortOrder: number;
}

interface FilterValue {
  id: string;
  name: string;
  nameAr: string;

  parentId: string | null;
  isLeaf: boolean;

  isActive: boolean;
  sortOrder: number;
}

const toNullableNumber = (
  value: unknown,
): number | null => {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return null;
  }

  const parsed =
    Number(value);

  return Number.isFinite(parsed)
    ? parsed
    : null;
};

const EditProduct: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [product, setProduct] = useState<any>(null);
  const [newImages, setNewImages] = useState<File[]>([]);
  const [tags, setTags] = useState<any[]>([]); // لتخزين العلامات
  const [selectedTag, setSelectedTag] = useState<string>(""); // العلامة المحددة
  const [loading, setLoading] = useState(false);
  const [lastVisible, setLastVisible] =
    useState<QueryDocumentSnapshot<DocumentData> | null>(null);
  const storage = getStorage();
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  const [mainImage, setMainImage] = useState<File | null>(null);
  const [mainImageUrl, setMainImageUrl] = useState<string | null>(null);
  const [extraImages, setExtraImages] = useState<File[]>([]);
  const [extraPreviews, setExtraPreviews] = useState<string[]>([]);
const [storedExtraImages, setStoredExtraImages] = useState<ProductImage[]>([]);
const [selectedExtraImageIds, setSelectedExtraImageIds] = useState<string[]>([]);
const [deletingImages, setDeletingImages] = useState(false);
  const [serialNumbers, setSerialNumbers] = useState<
    { id: string; point: number }[]
  >([]);
  const [isdeleteSerailModalOpen, setisdeleteSerailModalOpen] = useState(false);
  const [serialToDelete, setSerialToDelete] = useState<string | null>(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteImageModalOpen, setisDeleteImageModalOpen] = useState(false);
 const [imageToDelete, setImageToDelete] = useState<ProductImage | File | null>(
  null
);
  const [isFromFirestore, setIsFromFirestore] = useState(false);
  const [selectedLenses, setSelectedLenses] = useState<string[]>([]);



const [brands, setBrands] = useState<Brand[]>([]);
const [categories, setCategories] = useState<Category[]>([]);
const [filterOptions, setFilterOptions] = useState<FilterOption[]>([]);
const [filterValuesByOption, setFilterValuesByOption] = useState<
  Record<string, FilterValue[]>
>({});

const [selectedBrandIds, setSelectedBrandIds] = useState<string[]>([]);
const [selectedMainCategoryIds, setSelectedMainCategoryIds] = useState<string[]>(
  []
);
const [selectedSubCategoryIds, setSelectedSubCategoryIds] = useState<string[]>(
  []
);
const [selectedLeafCategoryIds, setSelectedLeafCategoryIds] = useState<string[]>(
  []
);

const [selectedAttributes, setSelectedAttributes] = useState<
  Record<string, string[]>
>({});


  const PAGE_SIZE = 100; // عدد العناصر التي يتم تحميلها في كل مرة
  const filteredSerialNumbers = serialNumbers.filter((serial) =>
    serial.id.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const [excelFile, setExcelFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false); // حالة تحميل البيانات
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setExcelFile(file);
      console.log("📂 تم تحديد الملف:", file.name);
    }
  };



 const fetchProductClassificationData = async () => {
  try {
    const brandsQuery = query(
      collection(db, "brands"),
      orderBy("sortOrder", "asc")
    );

    const brandsSnapshot = await getDocs(brandsQuery);

    const fetchedBrands: Brand[] = brandsSnapshot.docs
      .map((brandDoc) => ({
        id: brandDoc.id,
        ...(brandDoc.data() as Omit<Brand, "id">),
      }))
      .filter((brand) => brand.isActive !== false);

    setBrands(fetchedBrands);

    const categoriesQuery = query(
      collection(db, "categories"),
      orderBy("level", "asc"),
      orderBy("sortOrder", "asc")
    );

    const categoriesSnapshot = await getDocs(categoriesQuery);

    const fetchedCategories: Category[] = categoriesSnapshot.docs
      .map((categoryDoc) => ({
        id: categoryDoc.id,
        ...(categoryDoc.data() as Omit<Category, "id">),
      }))
      .filter((category) => category.isActive !== false);

    setCategories(fetchedCategories);

    const filterOptionsQuery = query(
      collection(db, "filterOptions"),
      orderBy("sortOrder", "asc")
    );

    const filterOptionsSnapshot = await getDocs(filterOptionsQuery);

    const fetchedFilterOptions: FilterOption[] = filterOptionsSnapshot.docs
      .map((filterDoc) => ({
        id: filterDoc.id,
        ...(filterDoc.data() as Omit<FilterOption, "id">),
      }))
      .filter((filterOption) => filterOption.isActive !== false);

    setFilterOptions(fetchedFilterOptions);

    const valuesMap: Record<string, FilterValue[]> = {};

    for (const filterOption of fetchedFilterOptions) {
      const valuesQuery = query(
        collection(db, "filterOptions", filterOption.id, "values"),
        orderBy("sortOrder", "asc")
      );

      const valuesSnapshot = await getDocs(valuesQuery);

     valuesMap[filterOption.id] =
  valuesSnapshot.docs
    .map((valueDoc) => {
      const data =
        valueDoc.data();

      return {
        id:
          valueDoc.id,

        name:
          String(
            data.name ??
              "",
          ),

        nameAr:
          String(
            data.nameAr ??
              "",
          ),

        parentId:
          typeof data.parentId ===
            "string" &&
          data.parentId.trim()
            ? data.parentId.trim()
            : null,

        isLeaf:
          typeof data.isLeaf ===
            "boolean"
            ? data.isLeaf
            : true,

        isActive:
          data.isActive !==
          false,

        sortOrder:
          typeof data.sortOrder ===
            "number"
            ? data.sortOrder
            : 0,
      } satisfies FilterValue;
    })
    .filter(
      (value) =>
        value.isActive,
    );
    }

    setFilterValuesByOption(valuesMap);
  } catch (error) {
    console.error("Error fetching product classification data:", error);
    toast.error("حدث خطأ أثناء تحميل البراندات والتصنيفات والفلاتر");
  }
};
  const handleUploadSerials = async () => {
    if (!excelFile) {
      alert("⚠️ يرجى تحديد ملف Excel أولا!");
      return;
    }

    if (!id || !product) {
      alert("⚠️ لا يوجد معرف للمنتج أو بيانات المنتج مفقودة!");
      return;
    }

    setIsUploading(true);

    try {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const data = event.target?.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0]; // اختيار الورقة الأولى
        const sheet = workbook.Sheets[sheetName];

        const serialNumbers: any[] = XLSX.utils.sheet_to_json(sheet);

        // 🔹 التحقق من وجود بيانات
        if (serialNumbers.length === 0) {
          alert("⚠️ الملف لا يحتوي على بيانات!");
          setIsUploading(false);
          return;
        }

        // 🔹 رفع البيانات إلى Firestore دفعة واحدة
        for (const serial of serialNumbers) {
          const serialId = serial.SerialNumber?.toString().trim(); // تأكد من أن الرقم بصيغة `string`
          if (!serialId) continue; // تخطي القيم الفارغة

          const serialRef = doc(db, "SerailNumber", serialId); // استخدام SerialNumber كـ ID

          await setDoc(serialRef, {
            point: product.points, // 🔹 استخدام `product.points`
            productId: id, // 🔹 إضافة `productId`
          });
        }

        toast.success("✅ تم اضافة سيريلات جديدة المنتج بنجاح!", {
          duration: 3000,
          position: "top-right",
          className: "edit-toast-success",
        });
        setIsUploading(false);
        setExcelFile(null);
      };

      reader.readAsBinaryString(excelFile);
    } catch (error) {
      console.error("❌ خطأ في رفع البيانات:", error);
      alert("❌ حدث خطأ أثناء رفع البيانات!");
      setIsUploading(false);
    }
  };

useEffect(() => {
  fetchProductClassificationData();
}, []);
  useEffect(() => {
    const fetchLenses = async () => {
      if (!id) return;
      const ayesCollection = collection(db, "product", id, "ayes");
      const ayesSnapshot = await getDocs(ayesCollection);
      const lenses = ayesSnapshot.docs.map((doc) => doc.data().name);
      setSelectedLenses(lenses); // تحديث العدسات المحددة
    };
    fetchLenses();
  }, [id]);

 const fetchProduct = async () => {
  try {
    if (!id) return;

    const productRef = doc(db, "product", id);
    const productSnap = await getDoc(productRef);

    if (!productSnap.exists()) {
      alert("المنتج غير موجود");
      navigate("/dashboard/home");
      return;
    }

    const productData = productSnap.data();

    
    setProduct({
      id: productSnap.id,
      ...productData,
        AgentPrice: productData.AgentPrice ?? "0",
        technPrice: productData.technPrice ?? "0",
    });
setSelectedBrandIds(
  productData.brandIds ||
    (productData.brandId ? [productData.brandId] : [])
);

setSelectedMainCategoryIds(
  productData.mainCategoryIds ||
    (productData.mainCategoryId ? [productData.mainCategoryId] : [])
);

setSelectedSubCategoryIds(
  productData.subCategoryIds ||
    (productData.subCategoryId ? [productData.subCategoryId] : [])
);

setSelectedLeafCategoryIds(
  productData.leafCategoryIds ||
    (productData.leafCategoryId ? [productData.leafCategoryId] : [])
);

setSelectedAttributes(productData.attributes || {});
    // ✅ تحميل الصورة الرئيسية
    setMainImageUrl(productData.imageUrl || null);

    // ✅ تحميل الصور الإضافية
    const imagesCollection = collection(db, "product", id, "productImages");
    const imagesSnapshot = await getDocs(imagesCollection);

    const imageUrls: ProductImage[] = imagesSnapshot.docs
      .map((imageDoc) => ({
        id: imageDoc.id,
        imageUrl: imageDoc.data().imageUrl || "",
      }))
      .filter((image) => image.imageUrl);

    setStoredExtraImages(imageUrls);
    setSelectedExtraImageIds([]);

   const [
  arabicDoc,
  englishDoc,
  kurdishDoc,
] = await Promise.all([
  getDoc(
    doc(
      db,
      "product",
      id,
      "Language",
      "ar",
    ),
  ),

  getDoc(
    doc(
      db,
      "product",
      id,
      "Language",
      "en",
    ),
  ),

  getDoc(
    doc(
      db,
      "product",
      id,
      "Language",
      "ku",
    ),
  ),
]);

const arabicDescription =
  arabicDoc.exists()
    ? String(
        arabicDoc.data()
          .productDescription ??
          "",
      )
    : String(
        productData
          .productDescription ??
          "",
      );

const englishDescription =
  englishDoc.exists()
    ? String(
        englishDoc.data()
          .productDescription ??
          "",
      )
    : "";

const kurdishDescription =
  kurdishDoc.exists()
    ? String(
        kurdishDoc.data()
          .productDescription ??
          "",
      )
    : "";

setProduct(
  (prod: any) => ({
    ...prod,

    arabicDescription,
    englishDescription,
    kurdishDescription,
  }),
);

    setProduct((prod: any) => ({
      ...prod,
      arabicDescription,
      englishDescription,
      kurdishDescription,
    }));
  } catch (error) {
    console.error("❌ خطأ في تحميل المنتج:", error);
    toast.error("حدث خطأ أثناء تحميل بيانات المنتج");
  }
};

const toggleArrayValue = (
  value: string,
  setter: React.Dispatch<React.SetStateAction<string[]>>
) => {
  setter((prev) =>
    prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
  );
};

const handleMainCategoryToggle = (categoryId: string) => {
  setSelectedMainCategoryIds((prev) => {
    const isRemoving = prev.includes(categoryId);

    if (isRemoving) {
      const subIdsToRemove = categories
        .filter((category) => category.parentId === categoryId)
        .map((category) => category.id);

      const leafIdsToRemove = categories
        .filter((category) => subIdsToRemove.includes(category.parentId || ""))
        .map((category) => category.id);

      setSelectedSubCategoryIds((current) =>
        current.filter((id) => !subIdsToRemove.includes(id))
      );

      setSelectedLeafCategoryIds((current) =>
        current.filter((id) => !leafIdsToRemove.includes(id))
      );

      return prev.filter((id) => id !== categoryId);
    }

    return [...prev, categoryId];
  });
};

const handleSubCategoryToggle = (categoryId: string) => {
  setSelectedSubCategoryIds((prev) => {
    const isRemoving = prev.includes(categoryId);

    if (isRemoving) {
      const leafIdsToRemove = categories
        .filter((category) => category.parentId === categoryId)
        .map((category) => category.id);

      setSelectedLeafCategoryIds((current) =>
        current.filter((id) => !leafIdsToRemove.includes(id))
      );

      return prev.filter((id) => id !== categoryId);
    }

    return [...prev, categoryId];
  });
};

const handleAttributeValueToggle = (
  filterOptionId: string,
  valueId: string,
) => {
  const filterValues =
    filterValuesByOption[
      filterOptionId
    ] ?? [];

  /**
   * الحصول على جميع الأبناء
   * والأحفاد للقيمة.
   */
  const getDescendantIds = (
    parentId: string,
  ): string[] => {
    const directChildren =
      filterValues.filter(
        (value) =>
          value.parentId ===
          parentId,
      );

    return directChildren.flatMap(
      (child) => [
        child.id,
        ...getDescendantIds(
          child.id,
        ),
      ],
    );
  };

  setSelectedAttributes(
    (prev) => {
      const currentValues =
        prev[
          filterOptionId
        ] ?? [];

      const isSelected =
        currentValues.includes(
          valueId,
        );

      /**
       * عند إلغاء Parent:
       * نحذف الأب وكل الأبناء
       * الموجودين تحته.
       */
      if (isSelected) {
        const descendantIds =
          getDescendantIds(
            valueId,
          );

        const idsToRemove =
          new Set([
            valueId,
            ...descendantIds,
          ]);

        const nextValues =
          currentValues.filter(
            (id) =>
              !idsToRemove.has(
                id,
              ),
          );

        return {
          ...prev,

          [filterOptionId]:
            nextValues,
        };
      }

      /**
       * عند الاختيار:
       * نضيف القيمة فقط.
       */
      return {
        ...prev,

        [filterOptionId]: [
          ...currentValues,
          valueId,
        ],
      };
    },
  );
};


  useEffect(() => {
    fetchProduct();
  }, [id]);

  useEffect(() => {
    const fetchTags = async () => {
      const tagsCollection = collection(db, "tags");
      const tagsSnapshot = await getDocs(tagsCollection);
      const fetchedTags = tagsSnapshot.docs.map((doc) => ({
        id: doc.id, // ✅ تعيين ID بشكل منفصل
        name: doc.data().name, // ✅ تجنب الانتشار العشوائي
        imageUrl: doc.data().ImageUrl,
      }));
      setTags(fetchedTags);
    };

    fetchTags();
  }, []);

  useEffect(() => {
    const fetchProductTags = async () => {
      try {
        if (!id) return;

        // ✅ جلب التاكات المحفوظة داخل المنتج `product/{id}/tags`
        const productTagsCollection = collection(db, "product", id, "tags");
        const productTagsSnapshot = await getDocs(productTagsCollection);
        const savedTags = productTagsSnapshot.docs.map((doc) => doc.id);

        setSelectedTags(savedTags);
      } catch (error) {
        console.error("❌ خطأ في جلب التاكات الخاصة بالمادة:", error);
      }
    };

    fetchProductTags();
  }, [id]);
  const toggleTagSelection = (tagId: string) => {
    setSelectedTags((prevTags) =>
      prevTags.includes(tagId)
        ? prevTags.filter((id) => id !== tagId)
        : [...prevTags, tagId]
    );
  };

  const fetchSerialNumbers = async (
    lastDoc?: QueryDocumentSnapshot<DocumentData>
  ) => {
    try {
      const serialNumberCollection = collection(db, "SerailNumber");

      // 🔎 إنشاء الاستعلام باستخدام `startAfter` فقط إذا كان `lastDoc` موجودًا
      let serialQuery = query(
        serialNumberCollection,
        where("productId", "==", id),
        limit(PAGE_SIZE)
      );

      if (lastDoc) {
        serialQuery = query(serialQuery, startAfter(lastDoc));
      }

      const serialSnapshot = await getDocs(serialQuery);

      if (!serialSnapshot.empty) {
        const fetchedSerials = serialSnapshot.docs.map((doc) => ({
          id: doc.id,
          point: doc.data().point,
        }));

        setSerialNumbers((prevSerials) => [...prevSerials, ...fetchedSerials]);

        // ✅ تعيين `lastVisible` للوثيقة الأخيرة
        setLastVisible(serialSnapshot.docs[serialSnapshot.docs.length - 1]);
      } else {
        setLastVisible(null); // لا يوجد مزيد من البيانات
      }
    } catch (error) {
      console.error("❌ خطأ في جلب البيانات:", error);
    }
  };

  useEffect(() => {
    fetchProduct();
    fetchSerialNumbers();
  }, [id]);


  const getCategoryPath = (categoryId: string): Category[] => {
  const categoriesMap = new Map(categories.map((category) => [category.id, category]));
  const path: Category[] = [];

  let currentCategory = categoriesMap.get(categoryId);

  while (currentCategory) {
    path.unshift(currentCategory);

    if (!currentCategory.parentId) {
      break;
    }

    currentCategory = categoriesMap.get(currentCategory.parentId);
  }

  return path;
};

const getSelectedCategoryLeafOrDeepestIds = (): string[] => {
  if (selectedLeafCategoryIds.length > 0) {
    return selectedLeafCategoryIds;
  }

  if (selectedSubCategoryIds.length > 0) {
    return selectedSubCategoryIds;
  }

  return selectedMainCategoryIds;
};

const buildSelectedCategoryPathData = () => {
  const deepestCategoryIds = getSelectedCategoryLeafOrDeepestIds();

  const paths = deepestCategoryIds
    .map((categoryId) => getCategoryPath(categoryId))
    .filter((path) => path.length > 0);

  const categoryPathKeys = Array.from(
    new Set(
      paths
        .map((path) => path.map((category) => category.id).join("/"))
        .filter(Boolean)
    )
  );

  const categoryPathNames = Array.from(
    new Set(paths.flatMap((path) => path.map((category) => category.name)))
  );

  const categoryPathIds = Array.from(
    new Set(paths.flatMap((path) => path.map((category) => category.id)))
  );

  return {
    categoryPathIds,
    categoryPathNames,
    categoryPathKey: categoryPathKeys[0] ?? null,
    categoryPathKeys,
  };
};
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!id || !product) {
      alert("⚠️ لا يوجد معرف للمنتج أو بيانات المنتج مفقودة!");
      return;
    }

    setLoading(true);

    try {
      // 🔹 مرجع إلى الوثيقة الخاصة بالمنتج في Firestore
      const productRef = doc(db, "product", id);

  



const categoryPathData = buildSelectedCategoryPathData();

const validFilterOptionIds =
  new Set(
    filterOptions.map(
      (filterOption) =>
        filterOption.id,
    ),
  );

const cleanedSelectedAttributes =
  Object.fromEntries(
    Object.entries(
      selectedAttributes,
    )
      .filter(
        ([filterOptionId]) =>
          validFilterOptionIds.has(
            filterOptionId,
          ),
      )
      .map(
        ([
          filterOptionId,
          valueIds,
        ]) => [
          filterOptionId,

          valueIds.filter(
            (valueId) =>
              filterValuesByOption[
                filterOptionId
              ]?.some(
                (value) =>
                  value.id ===
                  valueId,
              ),
          ),
        ],
      )
      .filter(
        ([, valueIds]) =>
          (
            valueIds as string[]
          ).length > 0,
      ),
  ) as Record<
    string,
    string[]
  >;

const selectedBrands = brands.filter((brand) =>
  selectedBrandIds.includes(brand.id)
);

const selectedMainCategories = categories.filter((category) =>
  selectedMainCategoryIds.includes(category.id)
);

const selectedSubCategories = categories.filter((category) =>
  selectedSubCategoryIds.includes(category.id)
);

const selectedLeafCategories = categories.filter((category) =>
  selectedLeafCategoryIds.includes(category.id)
);
      // 🔹 تحديث البيانات
   await productsApi.update(
  id,
  {
    code:
      product.code,

    name:
      product.name,

    points:
      toNullableNumber(
        product.points,
      ),

    location:
      product.location,

    price:
      toNullableNumber(
        product.price,
      ),

    AgentPrice:
      toNullableNumber(
        product.AgentPrice,
      ),

    technPrice:
      toNullableNumber(
        product.technPrice,
      ),

    rating:
      toNullableNumber(
        product.rating,
      ),

    quantity:
      toNullableNumber(
        product.quantity ??
          product.Quantity,
      ),

    Quantity:
      toNullableNumber(
        product.quantity ??
          product.Quantity,
      ),

    productDescription:
  product.arabicDescription ??
  product.productDescription ??
  "",

    AgentA:
      toNullableNumber(
        product.AgentA,
      ),

    AgentB:
      toNullableNumber(
        product.AgentB,
      ),

    AgentC:
      toNullableNumber(
        product.AgentC,
      ),

    AgentD:
      toNullableNumber(
        product.AgentD,
      ),

    AgentE:
      toNullableNumber(
        product.AgentE,
      ),

    AgentF:
      toNullableNumber(
        product.AgentF,
      ),

    AgentG:
      toNullableNumber(
        product.AgentG,
      ),

    AgentH:
      toNullableNumber(
        product.AgentH,
      ),

    brandId:
      selectedBrandIds[0] ??
      null,

    brandName:
      selectedBrands[0]?.name ??
      null,

    brandIds:
      selectedBrandIds,

    brandNames:
      selectedBrands.map(
        (brand) =>
          brand.name,
      ),

    mainCategoryId:
      selectedMainCategoryIds[0] ??
      null,

    mainCategoryName:
      selectedMainCategories[0]
        ?.name ??
      null,

    mainCategoryIds:
      selectedMainCategoryIds,

    mainCategoryNames:
      selectedMainCategories.map(
        (category) =>
          category.name,
      ),

    subCategoryId:
      selectedSubCategoryIds[0] ??
      null,

    subCategoryName:
      selectedSubCategories[0]
        ?.name ??
      null,

    subCategoryIds:
      selectedSubCategoryIds,

    subCategoryNames:
      selectedSubCategories.map(
        (category) =>
          category.name,
      ),

    leafCategoryId:
      selectedLeafCategoryIds[0] ??
      null,

    leafCategoryName:
      selectedLeafCategories[0]
        ?.name ??
      null,

    leafCategoryIds:
      selectedLeafCategoryIds,

    leafCategoryNames:
      selectedLeafCategories.map(
        (category) =>
          category.name,
      ),

    categoryPathIds:
      categoryPathData.categoryPathIds,

    categoryPathNames:
      categoryPathData.categoryPathNames,

    categoryPathKey:
      categoryPathData.categoryPathKey,

    categoryPathKeys:
      categoryPathData.categoryPathKeys,

   attributes:
  cleanedSelectedAttributes,

    showStatus:
      product.showStatus ??
      product.showStutas ??
      true,
  },
);

    
     const languageCollection =
  collection(
    db,
    "product",
    id,
    "Language",
  );

await Promise.all([
  setDoc(
    doc(
      languageCollection,
      "ar",
    ),
    {
      Language: "ar",
      productDescription:
        product.arabicDescription?.trim() ??
        "",
    },
    {
      merge: true,
    },
  ),

  setDoc(
    doc(
      languageCollection,
      "en",
    ),
    {
      Language: "en",
      productDescription:
        product.englishDescription?.trim() ??
        "",
    },
    {
      merge: true,
    },
  ),

  setDoc(
    doc(
      languageCollection,
      "ku",
    ),
    {
      Language: "ku",
      productDescription:
        product.kurdishDescription?.trim() ??
        "",
    },
    {
      merge: true,
    },
  ),
]);

      // حذف كل العدسات القديمة
      const ayesCollectionRef = collection(db, "product", id, "ayes");
      const ayesSnapshot = await getDocs(ayesCollectionRef);
      for (const lensDoc of ayesSnapshot.docs) {
        await deleteDoc(lensDoc.ref);
      }

      // إضافة العدسات الجديدة المختارة
      for (const lens of selectedLenses) {
        await addDoc(ayesCollectionRef, { name: lens });
      }

      // ...كود باقي التحديثات (التاكات وغيره)...

      // 🔹 تحديث التاكات المرتبطة بالمنتج
      const tagsCollectionRef = collection(db, "product", id, "tags");

      // ✅ حذف جميع التاكات السابقة
      const existingTagsSnapshot = await getDocs(tagsCollectionRef);
      existingTagsSnapshot.forEach(async (tagDoc) => {
        await deleteDoc(doc(tagsCollectionRef, tagDoc.id));
      });

      // ✅ إضافة التاكات الجديدة المحددة
      for (const tagId of selectedTags) {
        await setDoc(doc(tagsCollectionRef, tagId), { tagId });
      }

      // ✅ إظهار رسالة نجاح
      toast.success("✅ تم تحديث بيانات المنتج بنجاح!", {
        duration: 3000,
        position: "top-right",
       className: "edit-toast-success",
      });

      // 🔄 تحديث البيانات بعد الحفظ
      fetchProduct();
    } catch (error) {
      console.error("❌ خطأ في تحديث بيانات المنتج:", error);
      alert("❌ حدث خطأ أثناء تحديث المنتج!");
    }

    setLoading(false);
  };
const handleUpdateMainImage = async () => {
  if (!mainImage) {
    toast.error("يرجى اختيار صورة رئيسية جديدة");
    return;
  }

  if (!id) {
    toast.error("معرف المنتج غير موجود");
    return;
  }

  try {
    const safeFileName = `${Date.now()}-${mainImage.name}`;
    const mainImageRef = ref(storage, `product-images/${id}/main/${safeFileName}`);

    await uploadBytes(mainImageRef, mainImage);
    const uploadedMainImageUrl = await getDownloadURL(mainImageRef);

    const productRef = doc(db, "product", id);

    await updateDoc(productRef, {
      imageUrl: uploadedMainImageUrl,
    });

    setMainImage(null);
    setMainImageUrl(uploadedMainImageUrl);

    toast.success("✅ تم تحديث صورة المنتج بنجاح!", {
      duration: 3000,
      position: "top-right",
      className: "edit-toast-success",
    });

    await fetchProduct();
  } catch (error) {
    console.error("Error updating main image:", error);
    toast.error("حدث خطأ أثناء تحديث الصورة الرئيسية");
  }
};

  if (!product) {
    return <p>Loading...</p>;
  }

const handleAddExtraImages = async () => {
  if (!id) {
    toast.error("معرف المنتج غير موجود");
    return;
  }

  if (extraImages.length === 0) {
    toast.error("يرجى اختيار صور أولا");
    return;
  }

  try {
    for (const image of extraImages) {
      const safeFileName = `${Date.now()}-${image.name}`;
      const imageRef = ref(storage, `product-images/${id}/extra/${safeFileName}`);

      await uploadBytes(imageRef, image);
      const imageUrl = await getDownloadURL(imageRef);

      await addDoc(collection(db, "product", id, "productImages"), {
        imageUrl,
        createdAt: new Date(),
      });
    }

    toast.success("✅ تم رفع الصور الإضافية بنجاح!", {
      duration: 3000,
      position: "top-right",
      className: "edit-toast-success",
    });

    setExtraImages([]);
    await fetchProduct();
  } catch (error) {
    console.error("❌ خطأ في إضافة الصور الإضافية:", error);
    toast.error("حدث خطأ أثناء رفع الصور الإضافية");
  }
};
  // ❌ دالة حذف الرقم التسلسلي

  // ✅ جلب البيانات عند تحميل الصفحة

  const confirmDeleteAllSerials = async () => {
    if (!id) {
      alert("⚠️ لا يوجد معرف للمنتج!");
      return;
    }

    try {
      const serialNumberCollection = collection(db, "SerailNumber");
      const serialQuery = query(
        serialNumberCollection,
        where("productId", "==", id)
      );

      let serialSnapshot = await getDocs(serialQuery);
      let batchCount = 0;

      while (!serialSnapshot.empty) {
        const batch = writeBatch(db);

        serialSnapshot.docs.forEach((doc) => {
          batch.delete(doc.ref);
        });

        await batch.commit();
        batchCount++;

        // 🔄 جلب المزيد من الوثائق بعد الحذف
        serialSnapshot = await getDocs(serialQuery);

        console.log(`🗑️ تم حذف دفعة رقم ${batchCount}`);
      }
      // ✅ تفريغ حالة الأرقام التسلسلية بعد الحذف مباشرة
      setSerialNumbers([]);
      toast.success("✅ تم حذف جميع الأرقام التسلسلية بنجاح!", {
        duration: 3000,
        position: "top-right",
        className: "edit-toast-success",
      });

      setIsDeleteModalOpen(false);
      fetchSerialNumbers(); // 🔄 تحديث القائمة بعد الحذف
    } catch (error) {
      console.error("❌ خطأ في حذف الأرقام التسلسلية:", error);
      alert("❌ حدث خطأ أثناء حذف الأرقام التسلسلية!");
    }
  };

  const DeleteConfirmationModal: React.FC<DeleteModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
  }) => {
    const [inputValue, setInputValue] = useState(""); // ✅ حالة لتتبع الإدخال

    if (!isOpen) return null;

    return (
     <div className="edit-modal-overlay">
  <div className="edit-modal-card edit-modal-card-wide">
    <h2 className="edit-modal-title">تأكيد الحذف</h2>
    <p className="edit-modal-text">
      الرجاء كتابة في الحقل أدناه لتأكيد الحذف.
    </p>


          {/* ✅ حقل الإدخال */}
          <input
            type="text"
            placeholder="كود الحذف"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
      className="edit-product-input edit-modal-input-center"
          />

    <div className="edit-modal-actions edit-modal-actions-center">
            {/* ✅ زر الحذف مع شرط التفعيل */}
            <button
              onClick={() => onConfirm()}
              disabled={inputValue !== "SerailNumber"} // ✅ التحقق من الإدخال
             className={
          inputValue === "SerailNumber"
            ? "edit-btn edit-btn-danger"
            : "edit-btn edit-btn-disabled"
        }
            >
              نعم، حذف
            </button>

            <button
              onClick={onClose}
          className="edit-btn edit-btn-gray">
              إلغاء
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleClick = () => {
    setIsDeleteModalOpen(true);
  };

  const handleDeleteClick = (serialId: string) => {
    setSerialToDelete(serialId); // حفظ الرقم التسلسلي في المتغير
    setisdeleteSerailModalOpen(true); // فتح المودال
  };
  const confirmDeleteSerial = async () => {
    if (!serialToDelete) return;

    try {
      await deleteDoc(doc(db, "SerailNumber", serialToDelete));
      toast.success("تم حذف السيريال بنجاح", {
        duration: 3000,
        position: "top-right",
       className: "edit-toast-success",
      });
      setisdeleteSerailModalOpen(false);
      fetchSerialNumbers(); // تحديث القائمة بعد الحذف
    } catch (error) {
      console.error("❌ خطأ في حذف الرقم التسلسلي:", error);
    }
  };

  // ✅ دالة فتح المودال وتحديد الصورة التي سيتم حذفها
 const handleDeleteImageClick = (
  image: ProductImage | File,
  isFirestore: boolean
) => {
  setImageToDelete(image as any);
  setIsFromFirestore(isFirestore);
  setisDeleteImageModalOpen(true);
};

  const toggleExtraImageSelection = (imageId: string) => {
  setSelectedExtraImageIds((prev) =>
    prev.includes(imageId)
      ? prev.filter((id) => id !== imageId)
      : [...prev, imageId]
  );
};
  // ✅ دالة تأكيد الحذف
const confirmDeleteImage = async () => {
  if (!imageToDelete || !id) return;

  try {
    if (isFromFirestore && !(imageToDelete instanceof File)) {
      await deleteDoc(doc(db, "product", id, "productImages", imageToDelete.id));

      try {
        const storageImageRef = ref(storage, imageToDelete.imageUrl);
        await deleteObject(storageImageRef);
      } catch (storageError) {
        console.warn(
          "تم حذف الصورة من Firestore لكن لم يتم حذفها من Storage:",
          storageError
        );
      }

      setStoredExtraImages((prevImages) =>
        prevImages.filter((image) => image.id !== imageToDelete.id)
      );

      setSelectedExtraImageIds((prev) =>
        prev.filter((selectedId) => selectedId !== imageToDelete.id)
      );

      toast.success("✅ تم حذف الصورة بنجاح", {
        duration: 3000,
        position: "top-right",
        className: "edit-toast-success",
      });
    }

    if (!isFromFirestore && imageToDelete instanceof File) {
      setExtraImages((prevImages) =>
        prevImages.filter((file) => file !== imageToDelete)
      );

      toast.success("تم حذف الصورة من قائمة الرفع", {
        duration: 3000,
        position: "top-right",
        className: "edit-toast-success",
      });
    }
  } catch (error) {
    console.error("❌ خطأ في حذف الصورة:", error);
    toast.error("حدث خطأ أثناء حذف الصورة");
  } finally {
    setisDeleteImageModalOpen(false);
    setImageToDelete(null);
  }
};


  const deleteSelectedExtraImages = async () => {
  if (!id) return;

  if (selectedExtraImageIds.length === 0) {
    toast.error("يرجى تحديد صورة واحدة على الأقل");
    return;
  }

  const confirmed = window.confirm(
    `هل أنت متأكد من حذف ${selectedExtraImageIds.length} صورة؟`
  );

  if (!confirmed) return;

  try {
    setDeletingImages(true);

    const imagesToDelete = storedExtraImages.filter((image) =>
      selectedExtraImageIds.includes(image.id)
    );

    for (const image of imagesToDelete) {
      // حذف من Firestore
      await deleteDoc(doc(db, "product", id, "productImages", image.id));

      // محاولة حذف من Storage
      try {
        const storageImageRef = ref(storage, image.imageUrl);
        await deleteObject(storageImageRef);
      } catch (storageError) {
        console.warn(
          "تم حذف الصورة من Firestore لكن لم يتم حذفها من Storage:",
          storageError
        );
      }
    }

    setStoredExtraImages((prev) =>
      prev.filter((image) => !selectedExtraImageIds.includes(image.id))
    );

    setSelectedExtraImageIds([]);

    toast.success("✅ تم حذف الصور المحددة بنجاح", {
      duration: 3000,
      position: "top-right",
      className: "edit-toast-success",
    });
  } catch (error) {
    console.error("❌ خطأ في حذف الصور المحددة:", error);
    toast.error("حدث خطأ أثناء حذف الصور");
  } finally {
    setDeletingImages(false);
  }
};
  const lensOptions = ["2.8", "3.6", "4.0", "6.0"];


const mainCategories = categories.filter(
  (category) => category.type === "main" && category.level === 1
);

const subCategories = categories.filter(
  (category) =>
    category.type === "sub" &&
    category.level === 2 &&
    selectedMainCategoryIds.includes(category.parentId || "")
);

const leafCategories = categories.filter(
  (category) =>
    category.type === "leaf" &&
    category.level === 3 &&
    selectedSubCategoryIds.includes(category.parentId || "")
);

const selectedBrands = brands.filter((brand) =>
  selectedBrandIds.includes(brand.id)
);

const selectedMainCategories = categories.filter((category) =>
  selectedMainCategoryIds.includes(category.id)
);

const selectedSubCategories = categories.filter((category) =>
  selectedSubCategoryIds.includes(category.id)
);

const selectedLeafCategories = categories.filter((category) =>
  selectedLeafCategoryIds.includes(category.id)
);

  return (
   <div className="edit-product-page">
  <div className="edit-product-header">
     {/* أيقونة الرجوع للخلف */}

        {/* العنوان */}
       <h1 className="edit-product-title">تعديل بيانات منتج</h1>

        <FontAwesomeIcon
          icon={faArrowLeft}
          size="lg"
           className="edit-product-back-icon"
          onClick={() => navigate(-1)}
        />
        {/* أيقونة إعادة تعيين الحقول */}
      </div>

     <form onSubmit={handleSubmit} className="edit-product-form">
        {/* الحقول الأساسية */}

  
        <div>
          <label className="edit-product-label">
            كود المنتج:
          </label>
          <input
            type="text"
            value={product.code}
            onChange={(e) => setProduct({ ...product, code: e.target.value })}
            required
           className="edit-product-input"
          />
        </div>
        <div>
          <label  className="edit-product-label">
            اسم المنتج:
          </label>
          <input
            type="text"
            value={product.name}
            onChange={(e) => setProduct({ ...product, name: e.target.value })}
            required
            className="edit-product-input"
          />
        </div>
        <div>
          <label className="edit-product-label">
            نقاط المنتج:
          </label>
          <input
            type="text"
            value={product.points}
            onChange={(e) => setProduct({ ...product, points: e.target.value })}
            required
           className="edit-product-input"
          />
        </div>

        <div>
           <label className="edit-product-label">
            موقع خزن المنتج:
          </label>
          <input
            type="text"
            value={product.location}
            onChange={(e) =>
              setProduct({ ...product, location: e.target.value })
            }
            required
            className="edit-product-input"
          />
        </div>

        <div>
          <label className="edit-product-label">
            السعر:
          </label>
          <input
            type="text"
            value={product.price}
            onChange={(e) => setProduct({ ...product, price: e.target.value })}
            required
            className="edit-product-input"
          />
        </div>
<div>
  <label className="edit-product-label">
    سعر DPP:
  </label>

  <input
    type="text"
    value={product.AgentPrice ?? "0"}
    onChange={(e) =>
      setProduct({ ...product, AgentPrice: e.target.value })
    }
    required
    className="edit-product-input"
  />
</div>

<div>
  <label className="edit-product-label">
    سعر المنصب:
  </label>

  <input
    type="text"
    value={product.technPrice ?? "0"}
    onChange={(e) =>
      setProduct({ ...product, technPrice: e.target.value })
    }
    required
    className="edit-product-input"
  />
</div>
<div className="edit-product-full edit-product-section">
  <h3 className="edit-product-subtitle">
    البراندات والتصنيفات والفلاتر
  </h3>

  <div className="edit-classification-block">
    <h4 className="edit-classification-title">اختر البراندات:</h4>

    <div className="edit-selection-grid">
      {brands.map((brand) => (
        <label
          key={brand.id}
          className={
            selectedBrandIds.includes(brand.id)
              ? "edit-selection-card edit-selection-card-selected"
              : "edit-selection-card"
          }
        >
          <input
            type="checkbox"
            checked={selectedBrandIds.includes(brand.id)}
            onChange={() => toggleArrayValue(brand.id, setSelectedBrandIds)}
          />

          {brand.logoUrl && (
            <img
              src={brand.logoUrl}
              alt={brand.name}
              className="edit-selection-image"
            />
          )}

          <span>{brand.nameAr || brand.name}</span>
        </label>
      ))}
    </div>
  </div>

  <div className="edit-classification-block">
    <h4 className="edit-classification-title">اختر التصنيفات الرئيسية:</h4>

    <div className="edit-selection-grid">
      {mainCategories.map((category) => (
        <label
          key={category.id}
          className={
            selectedMainCategoryIds.includes(category.id)
              ? "edit-selection-card edit-selection-card-selected"
              : "edit-selection-card"
          }
        >
          <input
            type="checkbox"
            checked={selectedMainCategoryIds.includes(category.id)}
            onChange={() => handleMainCategoryToggle(category.id)}
          />

          <span>{category.nameAr || category.name}</span>
        </label>
      ))}
    </div>
  </div>

  <div className="edit-classification-block">
    <h4 className="edit-classification-title">اختر التصنيفات الفرعية:</h4>

    {selectedMainCategoryIds.length === 0 ? (
      <p className="edit-classification-hint">
        اختر تصنيف رئيسي أولاً حتى تظهر التصنيفات الفرعية.
      </p>
    ) : (
      <div className="edit-selection-grid">
        {subCategories.map((category) => (
          <label
            key={category.id}
            className={
              selectedSubCategoryIds.includes(category.id)
                ? "edit-selection-card edit-selection-card-selected"
                : "edit-selection-card"
            }
          >
            <input
              type="checkbox"
              checked={selectedSubCategoryIds.includes(category.id)}
              onChange={() => handleSubCategoryToggle(category.id)}
            />

            <span>{category.nameAr || category.name}</span>
          </label>
        ))}
      </div>
    )}
  </div>

  <div className="edit-classification-block">
    <h4 className="edit-classification-title">اختر التصنيفات النهائية:</h4>

    {selectedSubCategoryIds.length === 0 ? (
      <p className="edit-classification-hint">
        اختر تصنيف فرعي أولاً حتى تظهر التصنيفات النهائية.
      </p>
    ) : (
      <div className="edit-selection-grid">
        {leafCategories.map((category) => (
          <label
            key={category.id}
            className={
              selectedLeafCategoryIds.includes(category.id)
                ? "edit-selection-card edit-selection-card-selected"
                : "edit-selection-card"
            }
          >
            <input
              type="checkbox"
              checked={selectedLeafCategoryIds.includes(category.id)}
              onChange={() =>
                toggleArrayValue(category.id, setSelectedLeafCategoryIds)
              }
            />

            <span>{category.nameAr || category.name}</span>
          </label>
        ))}
      </div>
    )}
  </div>
<div className="edit-classification-block">
  <h4 className="edit-classification-title">
    الفلاتر:
  </h4>

  {filterOptions.map(
    (filterOption) => {
      const filterValues =
        filterValuesByOption[
          filterOption.id
        ] ?? [];

      const selectedValues =
        selectedAttributes[
          filterOption.id
        ] ?? [];

      /**
       * Root values
       */
      const rootValues =
        filterValues.filter(
          (value) =>
            !value.parentId,
        );

      /**
       * Parents المختارة التي
       * تحتوي أبناء.
       */
      const selectedParents =
        filterValues.filter(
          (value) =>
            selectedValues.includes(
              value.id,
            ) &&
            filterValues.some(
              (child) =>
                child.parentId ===
                value.id,
            ),
        );

      return (
        <div
          key={
            filterOption.id
          }
          className="edit-filter-group"
        >
          <h5 className="edit-filter-title">
            {filterOption.nameAr ||
              filterOption.name}
          </h5>

          {/* =====================
              المستوى الأول
          ====================== */}

          <div className="edit-classification-block">
            <h6 className="edit-classification-title">
              اختر القيمة:
            </h6>

            <div className="edit-selection-grid">
              {rootValues.map(
                (value) => {
                  const isSelected =
                    selectedValues.includes(
                      value.id,
                    );

                  const hasChildren =
                    filterValues.some(
                      (child) =>
                        child.parentId ===
                        value.id,
                    );

                  return (
                    <label
                      key={
                        value.id
                      }
                      className={
                        isSelected
                          ? "edit-selection-card edit-selection-card-selected"
                          : "edit-selection-card"
                      }
                    >
                      <input
                        type="checkbox"
                        checked={
                          isSelected
                        }
                        onChange={() =>
                          handleAttributeValueToggle(
                            filterOption.id,
                            value.id,
                          )
                        }
                      />

                      <span>
                        {value.nameAr ||
                          value.name}

                        {hasChildren && (
                          <small
                            style={{
                              marginRight:
                                "8px",
                              opacity:
                                0.65,
                            }}
                          >
                            يحتوي خيارات
                          </small>
                        )}
                      </span>
                    </label>
                  );
                },
              )}
            </div>
          </div>

          {/* =====================
              المستويات الداخلية
          ====================== */}

          {selectedParents.map(
            (parent) => {
              const children =
                filterValues.filter(
                  (value) =>
                    value.parentId ===
                    parent.id,
                );

              if (
                children.length === 0
              ) {
                return null;
              }

              return (
                <div
                  key={
                    parent.id
                  }
                  className="edit-classification-block"
                >
                  <h6 className="edit-classification-title">
                    الخيارات داخل{" "}
                    {parent.nameAr ||
                      parent.name}:
                  </h6>

                  <div className="edit-selection-grid">
                    {children.map(
                      (value) => {
                        const isSelected =
                          selectedValues.includes(
                            value.id,
                          );

                        const hasChildren =
                          filterValues.some(
                            (child) =>
                              child.parentId ===
                              value.id,
                          );

                        return (
                          <label
                            key={
                              value.id
                            }
                            className={
                              isSelected
                                ? "edit-selection-card edit-selection-card-selected"
                                : "edit-selection-card"
                            }
                          >
                            <input
                              type="checkbox"
                              checked={
                                isSelected
                              }
                              onChange={() =>
                                handleAttributeValueToggle(
                                  filterOption.id,
                                  value.id,
                                )
                              }
                            />

                            <span>
                              {value.nameAr ||
                                value.name}

                              {hasChildren && (
                                <small
                                  style={{
                                    marginRight:
                                      "8px",
                                    opacity:
                                      0.65,
                                  }}
                                >
                                  يحتوي خيارات
                                </small>
                              )}
                            </span>
                          </label>
                        );
                      },
                    )}
                  </div>
                </div>
              );
            },
          )}
        </div>
      );
    },
  )}
  
</div>

</div>
        <div>
           <label className="edit-product-label">
            التقييم:
          </label>
          <input
            type="text"
            value={product.rating}
            onChange={(e) => setProduct({ ...product, rating: e.target.value })}
            required
            className="edit-product-input"
          />
        </div>
        <div>
           <label className="edit-product-label">
            الكمية:
          </label>
          <input
            type="text"
            value={product.Quantity}
            onChange={(e) =>
              setProduct({ ...product, Quantity: e.target.value })
            }
            required
            className="edit-product-input"
          />
        </div>

        <div>
            <label className="edit-product-label">
            النقاط A:
          </label>
          <input
            type="text"
            value={product.AgentA}
            onChange={(e) => setProduct({ ...product, AgentA: e.target.value })}
            className="edit-product-input"
          />
        </div>

        <div>
            <label className="edit-product-label">
            النقاط B:
          </label>
          <input
            type="text"
            value={product.AgentB}
            onChange={(e) => setProduct({ ...product, AgentB: e.target.value })}
            className="edit-product-input"
          />
        </div>
        <div>
          <label className="edit-product-label">
            النقاط C:
          </label>
          <input
            type="text"
            value={product.AgentC}
            onChange={(e) => setProduct({ ...product, AgentC: e.target.value })}
            className="edit-product-input"
          />
        </div>

        <div>
           <label className="edit-product-label">
            النقاط D:
          </label>
          <input
            type="text"
            value={product.AgentD}
            onChange={(e) => setProduct({ ...product, AgentD: e.target.value })}
            className="edit-product-input"
          />
        </div>
        <div>
           <label className="edit-product-label">
            النقاط E:
          </label>
          <input
            type="text"
            value={product.AgentE}
            onChange={(e) => setProduct({ ...product, AgentE: e.target.value })}
            className="edit-product-input"
          />
        </div>
        <div>
           <label className="edit-product-label">
            النقاط F:
          </label>
          <input
            type="text"
            value={product.AgentF}
            onChange={(e) => setProduct({ ...product, AgentF: e.target.value })}
            className="edit-product-input"
          />
        </div>
        <div>
           <label className="edit-product-label">
            النقاط G:
          </label>
          <input
            type="text"
            value={product.AgentG}
            onChange={(e) => setProduct({ ...product, AgentG: e.target.value })}
          className="edit-product-input"
          />
        </div>
        <div>
           <label className="edit-product-label">
            النقاط H:
          </label>
          <input
            type="text"
            value={product.AgentH}
            onChange={(e) => setProduct({ ...product, AgentH: e.target.value })}
         className="edit-product-input"
          />
        </div>
        {/* وصف المنتج باللغات الثلاث */}
     <div className="edit-product-full edit-product-descriptions">
          {/* عربي */}
          <div>
             <label className="edit-product-label">
              الوصف بالعربية:
            </label>
            <textarea
              value={product.arabicDescription || ""}
              onChange={(e) =>
                setProduct({ ...product, arabicDescription: e.target.value })
              }
         className="edit-product-textarea"
              placeholder="الوصف بالعربية"
            ></textarea>
          </div>
          {/* إنجليزي */}
          <div>
           <label className="edit-product-label">
              Description (English):
            </label>
            <textarea
              value={product.englishDescription || ""}
              onChange={(e) =>
                setProduct({ ...product, englishDescription: e.target.value })
              }
            className="edit-product-textarea"
              placeholder="Description in English"
            ></textarea>
          </div>
          {/* كردي */}
          <div>
             <label className="edit-product-label">
              وەسفی بە کوردی:
            </label>
            <textarea
              value={product.kurdishDescription || ""}
              onChange={(e) =>
                setProduct({ ...product, kurdishDescription: e.target.value })
              }
            className="edit-product-textarea"
              placeholder="وەسف بە کوردی"
            ></textarea>
          </div>
        </div>

       <div className="edit-product-full">
  <h3 className="edit-product-subtitle">
    اختر العدسات (يمكن اختيار أكثر من واحدة):
  </h3>

  <div className="edit-product-checkboxes">
    {lensOptions.map((lens) => (
      <label key={lens} className="edit-product-checkbox-label">
        <input
          type="checkbox"
          checked={selectedLenses.includes(lens)}
          onChange={() => {
            setSelectedLenses((prev) =>
              prev.includes(lens)
                ? prev.filter((l) => l !== lens)
                : [...prev, lens]
            );
          }}
        />
        <span>{lens} mm</span>
      </label>
    ))}
  </div>
</div>

        {/* قائمة التاكات */}
     <div className="edit-product-full">
  <h3 className="edit-product-subtitle">اختر التاكات:</h3>

  <div className="edit-tags-box">
    {tags.map((tag) => (
      <div
        key={tag.id}
        className={
          selectedTags.includes(tag.id)
            ? "edit-tag-item edit-tag-item-selected"
            : "edit-tag-item"
        }
        onClick={() => toggleTagSelection(tag.id)}
      >
        <img
          src={tag.imageUrl}
          alt={tag.name}
          className="edit-tag-image"
        />

        <span className="edit-tag-name">{tag.name}</span>
      </div>
    ))}
  </div>
</div>
        {/* ✅ عرض الصورة الرئيسية */}

    <div className="edit-product-actions">
          <button
            type="submit"
            disabled={loading}
  className="edit-btn edit-btn-primary"          >
            {loading ? "جاري الإضافة..." : "تحديث البيانات الاساسية للمنتج"}
          </button>
        </div>
      </form>
      <div className="edit-product-divider"></div>
      {/* 
      <div className="col-span-2 m-4">
        <label className="block text-gray-700 font-semibold mb-2 text-lg font-custom">
          الصورة الرئيسية:
        </label>
        <div className="flex items-center space-x-6 p-4 rounded-lg border">
          {mainImageUrl && (
            <img
              src={mainImageUrl}
              alt="صورة المنتج"
              className="w-24 h-24 object-cover rounded-lg border-2 border-gray-300 shadow-lg"
            />
          )}
          <label className="cursor-pointer bg-cyan-600 text-white px-6 py-3 text-lg rounded-lg shadow hover:bg-cyan-700 transition font-custom">
            تغيير الصورة
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setMainImage(e.target.files?.[0] || null)}
              className="hidden"
            />
          </label>
          {mainImage && (
            <button
              onClick={handleUpdateMainImage}
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
            >
              تحديث
            </button>
          )}
        </div>
      </div> */}

    <div className="edit-product-section">
  <h2 className="edit-product-section-title">الصور الخاصة بالمنتج</h2>
</div>

  <div className="edit-product-section">
  <label className="edit-product-label">الصورة الرئيسية:</label>

  <div className="edit-image-panel">
    {mainImageUrl && (
      <img
        src={mainImageUrl}
        alt="صورة المنتج"
        className="edit-main-image"
      />
    )}

    <label className="edit-file-label">
      اختيار صورة رئيسية جديدة
      <input
        type="file"
        accept="image/*"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            setMainImage(file);
            setMainImageUrl(URL.createObjectURL(file));
          }
        }}
        className="edit-hidden-input"
      />
    </label>

    {mainImage && (
      <button
        type="button"
        onClick={handleUpdateMainImage}
        className="edit-btn edit-btn-success"
      >
        تحديث
      </button>
    )}
  </div>
</div>

      {/* ✅ عرض الصور الإضافية */}

      {/* ✅ عرض الصور الإضافية */}
    <div className="edit-product-section">
  <label className="edit-product-label">الصور الإضافية:</label>

  <div className="edit-extra-images-grid">
   {storedExtraImages.map((image, index) => {
  const isSelected = selectedExtraImageIds.includes(image.id);

  return (
    <div
      key={image.id}
      className={
        isSelected
          ? "edit-extra-image-card edit-extra-image-card-selected"
          : "edit-extra-image-card"
      }
    >
      <img
        src={image.imageUrl}
        alt={`صورة ${index + 1}`}
        className="edit-extra-image"
      />

      <label className="edit-image-select-check">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => toggleExtraImageSelection(image.id)}
        />
        تحديد
      </label>

      <button
        type="button"
        className="edit-image-single-delete"
        onClick={() => handleDeleteImageClick(image, true)}
      >
        حذف
      </button>
    </div>
  );
})}

    {extraImages.map((file, index) => (
      <img
        key={`new-${index}`}
        src={URL.createObjectURL(file)}
        alt={`صورة جديدة ${index + 1}`}
        className="edit-extra-image edit-extra-image-new"
        onClick={() => handleDeleteImageClick(file, false)}
      />
    ))}
  </div>

  <div className="edit-image-buttons">
    <label className="edit-file-label">
      إضافة صور جديدة
      <input
        type="file"
        multiple
        accept="image/*"
        onChange={(e) =>
          setExtraImages([
            ...extraImages,
            ...Array.from(e.target.files || []),
          ])
        }
        className="edit-hidden-input"
      />
    </label>
{selectedExtraImageIds.length > 0 && (
  <button
    type="button"
    onClick={deleteSelectedExtraImages}
    className="edit-btn edit-btn-danger"
    disabled={deletingImages}
  >
    {deletingImages
      ? "جارٍ الحذف..."
      : `حذف الصور المحددة (${selectedExtraImageIds.length})`}
  </button>
)}
    {extraImages.length > 0 && (
      <button
        type="button"
        onClick={handleAddExtraImages}
        className="edit-btn edit-btn-success"
      >
        رفع الصور
      </button>
    )}
  </div>
</div>
      {/* ✅ مودال تأكيد الحذف */}
      {isDeleteImageModalOpen && (
        <div className="edit-modal-overlay">
    <div className="edit-modal-card">
      <h2 className="edit-modal-title">تأكيد حذف الصورة</h2>
           <p className="edit-modal-text">
              هل أنت متأكد أنك تريد حذف هذه الصورة؟
            </p>
            <div className="edit-modal-actions">
              <button
                onClick={() => setisDeleteImageModalOpen(false)}
                 className="edit-btn edit-btn-gray"
              >
                إلغاء
              </button>
              <button
                onClick={confirmDeleteImage}
               className="edit-btn edit-btn-danger"
              >
                حذف
              </button>
            </div>
          </div>
        </div>
      )}

<div className="edit-product-divider"></div>
      {/* 🛠 قائمة الأرقام التسلسلية */}
     <div className="edit-product-section">
  <h3 className="edit-product-subtitle">الأرقام التسلسلية:</h3>

  <div className="edit-serial-toolbar">
    <div className="edit-search-wrapper">
      <FontAwesomeIcon icon={faSearch} className="edit-search-icon" />

      <input
        type="text"
        placeholder="بحث عن الرقم التسلسلي..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="edit-search-input"
      />
    </div>

    <button
      type="button"
      onClick={() => setIsModalOpen(true)}
      className="edit-btn edit-btn-primary"
    >
      <FontAwesomeIcon className="edit-btn-icon" icon={faPlus} />
      إضافة
    </button>

    <button
      type="button"
      onClick={handleClick}
      className="edit-btn edit-btn-danger"
    >
      <FontAwesomeIcon className="edit-btn-icon" icon={faTrash} />
      حذف الجميع
    </button>

    <DeleteConfirmationModal
      isOpen={isDeleteModalOpen}
      onClose={() => setIsDeleteModalOpen(false)}
      onConfirm={confirmDeleteAllSerials}
    />
  </div>
</div>
      {filteredSerialNumbers.length > 0 ? (
     <div className="edit-serial-grid">
  {filteredSerialNumbers.map((serial) => (
    <div key={serial.id} className="edit-serial-card">
      <span className="edit-serial-number">{serial.id}</span>

      <button
        type="button"
        onClick={() => handleDeleteClick(serial.id)}
        className="edit-serial-delete"
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>
    </div>
  ))}
</div>
      ) : (
       <div className="edit-empty-state">
  <FontAwesomeIcon icon={faFolderOpen} className="edit-empty-icon" />
  <p>لا توجد أرقام تسلسلية لهذا المنتج.</p>
</div>
      )}

      {/* 🔹 زر تحميل المزيد */}
      {lastVisible !== null && (
        <button
          onClick={() => fetchSerialNumbers(lastVisible)}
  className="edit-btn edit-btn-primary edit-load-more-btn"        >
          تحميل المزيد
        </button>
      )}

      {/* 📌 مودال إضافة رقم تسلسلي */}
    {isModalOpen && (
  <div className="edit-modal-overlay">
    <div className="edit-modal-card">
      <h2 className="edit-modal-title">إضافة أرقام تسلسلية</h2>

      <label className="edit-file-label edit-file-label-light">
        📂 اختر ملف Excel
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileUpload}
          className="edit-hidden-input"
        />
      </label>

      {excelFile && (
        <p className="edit-selected-file">
          الملف المختار: {excelFile.name}
        </p>
      )}

      <div className="edit-modal-actions">
        <button
          type="button"
          onClick={() => setIsModalOpen(false)}
          className="edit-btn edit-btn-gray"
        >
          إلغاء
        </button>

        <button
          type="button"
          onClick={handleUploadSerials}
          className={
            excelFile
              ? "edit-btn edit-btn-success"
              : "edit-btn edit-btn-disabled"
          }
          disabled={!excelFile || isUploading}
        >
          {isUploading ? "جارِ التحميل..." : "رفع"}
        </button>
      </div>
    </div>
  </div>
)}

    {isdeleteSerailModalOpen && (
  <div className="edit-modal-overlay">
    <div className="edit-modal-card">
      <h2 className="edit-modal-title">حذف رقم تسلسلي</h2>

      <div className="edit-modal-actions">
        <button
          type="button"
          onClick={() => setisdeleteSerailModalOpen(false)}
          className="edit-btn edit-btn-gray"
        >
          إلغاء
        </button>

        <button
          type="button"
          onClick={confirmDeleteSerial}
          className="edit-btn edit-btn-danger"
        >
          حذف
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default EditProduct;
